import React, { FC, Fragment } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DHDialog: FC<any> = (props: any) => {
    const { title, onClose, children, actions, disableBackdropClick, height, ...propsToDialog } = props;

    const handleClose = (event: object) => {
        if (disableBackdropClick) return;
        onClose(event);
    };

    return (
        <Fragment>
            <Dialog {...propsToDialog} onClose={handleClose}>
                <Box onClick={(e) => e.stopPropagation()}>
                    <DialogTitle>
                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            <Box>{title}</Box>
                            <IconButton onClick={onClose} sx={{ marginRight: '-10px' }} data-test="dh-dialog.close-btn">
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </DialogTitle>

                    <DialogContent sx={{ minHeight: height }}>{children}</DialogContent>

                    {actions && <DialogActions>{actions} </DialogActions>}
                </Box>
            </Dialog>
        </Fragment>
    );
};

export default DHDialog;
